import {IQuizAnswer, IQuizQuestion} from "@buildwitt/shapeshift-types";
import {FC} from "react";
import {makeStyles} from "tss-react/mui";
import {CenteredContainer} from "@/components/pageBase/centeredContainer";
import {palette} from "@/constants";
import {useSSTranslation} from "@/i18n/useSSTranslation";
import {QuizQuestionListContainer} from "@buildwitt/shapeshift-common/v1/quiz";

interface IProps {
	questions: IQuizQuestion[];
	onSubmit: (answers: IQuizAnswer[]) => void;
}

const useStyles = makeStyles()((theme) => ({
	centeredContainer: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		textAlign: "center"
	},
	quizQuestionContainer: {
		textAlign: "left",
		"[class*='dragToOrderQuestion'], [class*='matchingOrderQuestion']": {
			"[class*='questionOption']": {
				padding: 0
			}
		},
		"[class*='title']": {
			fontSize: "24px"
		},
		"[class*='answerCounter']": {
			height: "36px",
			background: palette.grey10,
			boxSizing: "border-box",
			justifyContent: "center",
			display: "flex",
			flexDirection: "column",
			fontWeight: 600,
			fontSize: "14px"
		},
		"[class*='questionCounter']": {
			fontFamily: "Titillium Web,sans-serif",
			color: theme.palette.common.white,
			"& span": {
				color: theme.palette.primary.main
			}
		},
		"[class*='inputContainer']": {
			background: palette.grey05,
			border: palette.grey20 + " 1px solid"
		},
		"[class*='questionOption']": {
			minHeight: "56px",
			boxSizing: "border-box",
			background: "#282828",
			border: palette.grey20 + " 1px solid",
			"[class*='childrenContainer']": {
				padding: "5px 13px"
			},
			"[class*='optionId']": {
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				textAlign: "center",
				height: "34px",
				background: palette.grey10,
				fontSize: "14px",
				fontWeight: 600,
				boxSizing: "border-box",
				width: "34px",
				borderRadius: "5px",
				border: palette.grey20 + " 1px solid"
			},
			"&.active": {
				background: palette.grey10,
				borderColor: palette.grey40,
				"[class*='optionId']": {
					background: theme.palette.primary.main,
					color: theme.palette.common.black
				}
			}
		}
	}
}));

export const MiniQuizzerQuestions: FC<IProps> = ({questions, onSubmit}) => {
	const {classes} = useStyles();
	const {t} = useSSTranslation();
	const translations = {
		submitAnswers: t("quiz.submit_answers", "Submit answers"),
		nextQuestion: t("quiz.next_question", "Next question"),
		previousQuestion: t("quiz.previous_question", "Previous question"),
		back: t("quiz.back", "Back"),
		questionText: t("quiz.question_text", "Question"),
		ofText: t("quiz.of_text", "of"),
		oneAnswer: t("quiz.one_answer", "1 answer"),
		multipleAnswers: t("quiz.multiple_answers", "answers"),
		dragToOrder: t("quiz.drag_to_order", "Drag rows to correct order")
	};

	return (
		<CenteredContainer className={classes.centeredContainer}>
			<QuizQuestionListContainer
				className={classes.quizQuestionContainer}
				questions={questions}
				onSubmit={onSubmit}
				translations={translations}
			/>
		</CenteredContainer>
	);
};
